import { useMemo } from 'react';
import classNames from 'classnames';
import { FooterBottom, FooterMiddle, FooterTop } from './components';

type FooterProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-footer';

export const Footer = ({ className }: FooterProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	return (
		<footer className={wrapperClassName}>
			<FooterTop />
			<FooterMiddle />
			<FooterBottom />
		</footer>
	);
};
